import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { Card } from 'primereact/card'
import { InputNumber } from 'primereact/inputnumber'
import { useAppSelector } from '../../../../hooks'
import { useDispatch, useSelector } from 'react-redux'
import { getTags } from '../../slice/sensor.slice'
import { _saveAlert, _fetchEnginList } from '../../api/api'
import { Toast } from 'primereact/toast'
import { Tooltip } from 'primereact/tooltip'
import { useRef } from 'react'
import {OlangItem} from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import { fetchSitesClient, getSelectedSiteClient } from '../../../../store/slices/customer.slice'
import { fetchStaffList, getStaffList } from '../../../LogsTracking/slice/logs.slice'
import { fetchSites, getSites } from '../../../Site/slice/site.slice'
let types = [
  {label: 'Basse', value: 'Basse'},
  {label: 'Moyenne', value: 'Moyenne'},
  {label: 'Haute', value: 'Haute'},
]

let operators = [
  {label: 'Et', value: '&&'},
  {label: 'Ou', value: '||'}
]

let comparison_operators = [
  {label: 'Supérieur à (>)', value: '>', icon: 'pi pi-angle-right'},
  {label: 'Inférieur à (<)', value: '<', icon: 'pi pi-angle-left'},
  {label: 'Égal à (=)', value: '=', icon: 'pi pi-equals'},
  {label: 'Supérieur ou égal (>=)', value: '>=', icon: 'pi pi-angle-double-right'},
  {label: 'Inférieur ou égal (<=)', value: '<=', icon: 'pi pi-angle-double-left'},
]

let entity_types = [
  // {label: 'Tag', value: 'tag'},
  {label: 'Capteurs', value: 'engin'},
  {label: 'Zone', value: 'area'},
]

let sensor_types = [
  {label: 'Temperature', value: 'temperature'},
  {label: 'Humidité', value: 'humidity'},
  {label: 'Porte', value: 'door'},
]

function AlertEditor({ onBack, selectedAlert = null }) {
  const [inputs, setInputs] = useState({})
  const [formatedWorksites, setFormatedWorksites] = useState([])
  const tags = useSelector(getTags)
  const dispatch = useDispatch()
  const toast = useRef(null)
  const worksites = useAppSelector(getSites)
  const staff = useAppSelector(getStaffList)

  let [conditionInputs, setConditionsInputs] = useState({})
  const [loading, setLoading] = useState(false)
  const [engins, setEngins] = useState([])
  const [loadingEngins, setLoadingEngins] = useState(false)
  
  const back = () => {
    if (onBack) {
      onBack()
    }
  }

  const onInputChanged = (e) => {
    const { name, value } = e.target;
    setInputs(prev => ({ ...prev, [name]: value }));
  }

  const onConditionChanged = (e) => {
    const { name, value } = e.target;
    setConditionsInputs(prev => ({ ...prev, [name]: value }));
  }

  const onConditionValueChanged = (value) => {
    setConditionsInputs(prev => ({ ...prev, conditionValue: value }));
  }

  const getOperatorText = (op) => {
     let found = operators.find(o => o.value === op)
     return found ? found.label : ''
  }

  const addCondition = () => {
    if (conditionInputs?.conditionOperator && conditionInputs?.conditionValue !== undefined && conditionInputs?.sensor) {
      // Construire la condition au format: >25, <10, =50, etc.
      const condition = conditionInputs.conditionOperator + conditionInputs.conditionValue
      let dt = { 
        ...conditionInputs, 
        condition,
        operator: conditionInputs.operator || '', 
        id: (inputs?.conditions?.length || 0) + 1 
      }
      setInputs(prev => ({ ...prev, conditions: [...(prev?.conditions || []), dt] }))
      setConditionsInputs({})
    }
  }

  const removeCondition = (index) => {
    setInputs(prev => ({
      ...prev,
      conditions: prev.conditions?.filter((_, i) => i !== index) || []
    }))
  }

  const save = async () => {
    setLoading(true)
    try {
      let dt = _.cloneDeep(inputs)
      
      // Traitement des utilisateurs
      if (Array.isArray(dt.users)) {
        dt.users = dt.users.join(',')
      }
      
      // Traitement des emails
      if (Array.isArray(dt.emails)) {
        dt.emails = dt.emails.join(',')
      }

      // Validation : au moins une condition doit être configurée
      if (!dt.conditions || dt.conditions.length === 0) {
        toast.current?.show({
          severity: 'warn',
          summary: 'Configuration incomplète',
          detail: 'Veuillez configurer au moins une condition avant de valider l\'alerte',
          life: 4000
        })
        setLoading(false)
        return
      }

      // Traitement des conditions
      if (Array.isArray(dt.conditions) && dt.conditions.length > 0) {
        dt.condition = dt.conditions.reduce((acc, cur) => {
          return acc + (cur.operator + cur.sensor + cur.condition)
        }, '')
      } else {
        dt.condition = ''
      }

      if(dt.srcObject == 'area'){
        let split = dt.srcId.split('#')
        dt.srcObject = (split[1] || '').toLowerCase()
        dt.srcId = split[0]
      }

      // Validation des conditions (vérifier que les conditions sont valides)
      if (dt.conditions && dt.conditions.length > 0 && !dt.condition) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Les conditions d\'alerte sont invalides',
          life: 3000
        })
        setLoading(false)
        return
      }

      // Champs requis
      if (!dt.code || !dt.label || !dt.type || !dt.srcObject || !dt.srcId) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Veuillez remplir tous les champs obligatoires (Code, Nom, Catégorie, Entité)',
          life: 3000
        })
        setLoading(false)
        return
      }

      console.log('Alerte à sauvegarder:', dt)
      // return
      // Détecter si c'est une modification ou une création
      const isEdit = selectedAlert && (selectedAlert.uid || selectedAlert.id || selectedAlert.UID)
      console.log('Mode édition:', isEdit, 'selectedAlert:', selectedAlert)
      
      const response = await _saveAlert(dt)
      console.log('Réponse sauvegarde alerte:', response)
      if (response.success) {
        toast.current?.show({
          severity: 'success',
          summary: 'Succès',
          detail: isEdit ? 'Alerte mise à jour avec succès' : 'Alerte créée avec succès',
          life: 3000
        })
        setTimeout(() => {
          back()
        }, 1500)
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: response.message || (isEdit ? 'Erreur lors de la mise à jour de l\'alerte' : 'Erreur lors de la création de l\'alerte'),
          life: 3000
        })
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error)
      const isEdit = selectedAlert && (selectedAlert.uid || selectedAlert.id || selectedAlert.UID)
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail: isEdit ? 'Erreur de connexion lors de la mise à jour de l\'alerte' : 'Erreur de connexion lors de la création de l\'alerte',
        life: 3000
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    if (selectedAlert) {
      let dt = _.cloneDeep(selectedAlert)
      if (dt?.users) {
        dt.users = dt.users.split(',').map(o => +o.trim())
      } else {
        dt.users = []
      }
      dt.message = dt.message || dt.Message
      dt.code = dt.code || dt.Code
      dt.id = dt.UID || dt.uid
      dt.srcId = dt.srcId || dt.srcID
      dt.emails = dt.emails || dt.Emails
      
      // Traitement des conditions existantes
      if (dt.condition && typeof dt.condition === 'string') {
        // Parser la string de condition comme "temperature>20||humidity<50&&door=1"
        try {
          const conditionString = dt.condition
          console.log('🔧 AlertEditor - Parsing condition string:', conditionString)
          
          // Séparer par les opérateurs || et &&
          const parts = conditionString.split(/(\|\||&&)/)
          const conditions = []
          let currentOperator = null
          
          for (let i = 0; i < parts.length; i++) {
            const part = parts[i].trim()
            
            if (part === '||' || part === '&&') {
              currentOperator = part
            } else if (part && part !== '') {
              // Parser une condition individuelle comme "temperature>20"
              const conditionMatch = part.match(/^(\w+)([<>=!]+)(.+)$/)
              if (conditionMatch) {
                const [, sensor, operator, value] = conditionMatch
                conditions.push({
                  sensor: sensor,
                  conditionOperator: operator,
                  conditionValue: parseFloat(value) || value,
                  condition: operator + value,
                  operator: currentOperator || '',
                  id: conditions.length + 1
                })
                currentOperator = null // Reset après utilisation
              }
            }
          }
          
          dt.conditions = conditions
          console.log('🔧 AlertEditor - Conditions parsées:', conditions)
        } catch (e) {
          console.warn('Erreur parsing condition string:', e)
          dt.conditions = []
        }
      } else if (dt.conditions) {
        // Si les conditions sont déjà un array (cas existant)
        if (typeof dt.conditions === 'string') {
          try {
            dt.conditions = JSON.parse(dt.conditions)
          } catch (e) {
            console.warn('Erreur parsing conditions JSON:', e)
            dt.conditions = []
          }
        }
        if (!Array.isArray(dt.conditions)) {
          dt.conditions = []
        }
      } else {
        dt.conditions = []
      }
      
      console.log('🔧 AlertEditor - Données chargées pour édition:', dt)
      console.log('🔧 AlertEditor - Conditions finales:', dt.conditions)
      setInputs(dt)
    } else {
      setInputs({
        conditions: [],
        users: [],
        emails: ''
      })
    }
  }, [selectedAlert])

  const loadEngins = async () => {
    try {
      setLoadingEngins(true)
      console.log('📊 Chargement des engins pour AlertEditor...')
      
      const response = await _fetchEnginList()
      console.log('📊 Réponse API engins:', response)
      
      if (response.data && response.data.success && response.data.result) {
        const enginsData = Array.isArray(response.data.result) ? response.data.result : []
        console.log('📊 Engins data received:', enginsData.length)
        
        // Transformer les données engin pour le dropdown
        const transformedEngins = enginsData.map((engin) => ({
          label: engin.title || engin.label || engin.reference || `Engin-${engin.uid}`,
          value: engin.id,
          id: engin.id,
          uid: engin.uid,
          tagname: engin.tagname
        }))
        
        setEngins(transformedEngins)
        console.log('✅ Engins chargés pour AlertEditor:', transformedEngins.length)
      } else {
        console.log('❌ Aucun engin reçu')
        setEngins([])
      }
      
    } catch (error) {
      console.error('🚨 Erreur lors du chargement des engins:', error)
      setEngins([])
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Impossible de charger la liste des engins',
        life: 3000
      })
    } finally {
      setLoadingEngins(false)
    }
  }

  useEffect(() => {
    // dispatch(fetchTagList())
    dispatch(fetchStaffList())
    dispatch(fetchSites())
    loadEngins()
  }, [dispatch])

  useEffect(()=>{
    if(Array.isArray(worksites)){
      setFormatedWorksites(worksites.map(o=>({label: o.name,type: o.type , value: o.id+'#'+o.type})))
    }
  },[worksites])

  return (
    <div className="flex align-items-center justify-content-center">
      <Toast ref={toast} />
      <div className="w-10">
        <div className="flex align-items-center justify-content-between mb-3">
          <Button 
            onClick={back} 
            icon="pi pi-arrow-left" 
            className="p-button-text" 
            label="Retour"
          />
          <h2 className="m-0">
            <OlangItem olang={selectedAlert ? 'alert.edit' : 'alert.create'} />
          </h2>
        </div>
        <Divider />
        
        <div className='flex flex-wrap'>
          <div className='w-4 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.code' /> *
            </label>
            <InputText 
              name="code" 
              onChange={onInputChanged} 
              className='w-full'
              value={inputs.code || ''}
              placeholder="Code de l'alerte"
            />
          </div>
          
          <div className='w-4 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.name' /> *
            </label>
            <InputText 
              name="label" 
              onChange={onInputChanged}  
              className='w-full'
              value={inputs.label || ''}
              placeholder="Nom de l'alerte"
            />
          </div>
          
          <div className='w-4 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.category' /> *
            </label>
            <Dropdown 
              name="type" 
              className='w-full'
              options={types}
              value={inputs.type}
              onChange={onInputChanged}
              placeholder="Sélectionner une catégorie"
            />
          </div>
          
          <div className='w-6 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.entity_type' />
            </label>
            <Dropdown 
              name="srcObject" 
              className='w-full'
              options={entity_types}
              value={inputs.srcObject}
              onChange={onInputChanged}
              placeholder="Type d'entité"
            />
          </div>
          
          <div className='w-6 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.entity' /> *
            </label>
            <Dropdown 
              name="srcId" 
              className='w-full'
              options={inputs?.srcObject === 'engin' ? engins :
                              formatedWorksites}
              value={inputs.srcId}
              onChange={onInputChanged}
              filter
              loading={loadingEngins}
              placeholder={loadingEngins ? "Chargement..." : "Sélectionner une entité"}
            />
          </div>
          
          <div className='w-12 p-2'>
            <label className="block mb-3 font-semibold text-lg">
              <i className="pi pi-filter mr-2 text-primary"></i>
              <OlangItem olang='alert.conditions' />
            </label>
            
            <Card className="mb-3 shadow-2">
              <div className="p-3">
                {/* Affichage des conditions existantes */}
                {Array.isArray(inputs?.conditions) && inputs?.conditions.length > 0 ? (
                  <div className='mb-3'>
                    <h4 className="m-0 mb-2 text-sm text-600">Conditions configurées :</h4>
                    <div className='flex align-items-center gap-2 flex-wrap'>
                      {inputs?.conditions.map((c, i) => (
                        <React.Fragment key={i}>
                          <div className="flex align-items-center gap-2 p-3 border-round bg-blue-50 border-1 border-blue-200">
                            <i className="pi pi-microchip text-blue-600"></i>
                            <span className="font-semibold text-blue-900">
                              {sensor_types.find(s => s.value === c.sensor)?.label || c.sensor}
                            </span>
                            <span className="font-bold text-blue-700">{c.condition}</span>
                            <Button 
                              icon="pi pi-times"
                              className="p-button-rounded p-button-text p-button-danger p-button-sm"
                              onClick={() => removeCondition(i)}
                              tooltip="Supprimer"
                            />
                          </div>
                          {
                            inputs?.conditions[i + 1] ? (
                              <span className='px-3 py-2 bg-purple-100 border-round font-semibold text-purple-700'>
                                {getOperatorText(inputs?.conditions[i + 1]?.operator)}
                              </span>
                            ) : null
                          }
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4 text-600">
                    <i className="pi pi-info-circle text-2xl mb-2 block"></i>
                    <p className="m-0">Aucune condition définie. Ajoutez-en une ci-dessous.</p>
                  </div>
                )}
                
                <Divider />
                
                {/* Formulaire d'ajout de condition */}
                <h4 className="m-0 mb-3 text-sm text-600">Ajouter une nouvelle condition :</h4>
                <div className='grid'>
                  {inputs?.conditions?.length > 0 && (
                    <div className="col-12 md:col-3">
                      <label className="block mb-2 font-medium text-sm">
                        <i className="pi pi-link mr-1"></i>
                        Opérateur logique
                      </label>
                      <Dropdown 
                        name="operator"
                        className='w-full'
                        placeholder='Et / Ou'
                        options={operators}
                        value={conditionInputs.operator}
                        onChange={onConditionChanged}
                      />
                    </div>
                  )}
                  
                  <div className="col-12 md:col-3">
                    <label className="block mb-2 font-medium text-sm">
                      <i className="pi pi-microchip mr-1"></i>
                      Type de capteur *
                    </label>
                    <Dropdown 
                      name="sensor"
                      className='w-full'
                      options={sensor_types}
                      value={conditionInputs.sensor}
                      placeholder='Sélectionner...'
                      onChange={onConditionChanged}
                    />
                  </div>
                  
                  <div className="col-12 md:col-3">
                    <label className="block mb-2 font-medium text-sm">
                      <i className="pi pi-sort-alt mr-1"></i>
                      Comparaison *
                    </label>
                    <Dropdown 
                      name="conditionOperator"
                      className='w-full'
                      options={comparison_operators}
                      value={conditionInputs.conditionOperator}
                      placeholder='Opérateur...'
                      onChange={onConditionChanged}
                    />
                  </div>
                  
                  <div className="col-12 md:col-3">
                    <label className="block mb-2 font-medium text-sm">
                      <i className="pi pi-hashtag mr-1"></i>
                      Valeur *
                    </label>
                    <InputNumber 
                      className='w-full'
                      placeholder='Ex: 25'
                      value={conditionInputs.conditionValue}
                      onValueChange={(e) => onConditionValueChanged(e.value)}
                      mode="decimal"
                      minFractionDigits={0}
                      maxFractionDigits={2}
                    />
                  </div>
                  
                  <div className="col-12">
                    <Button 
                      onClick={addCondition} 
                      label='Ajouter la condition' 
                      icon="pi pi-plus" 
                      className="w-full p-button-success"
                      disabled={!conditionInputs.sensor || !conditionInputs.conditionOperator || conditionInputs.conditionValue === undefined}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
          
          <div className='w-12 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='description' />
            </label>
            <InputTextarea 
              name="description" 
              className='w-full' 
              value={inputs.description || ''}
              rows={3}
              onChange={onInputChanged}
              placeholder="Description de l'alerte"
            />
          </div>
          
          <div className='w-12 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='message' />
            </label>
            <InputTextarea 
              name="message" 
              className='w-full' 
              rows={3}
              value={inputs.message || ''}
              onChange={onInputChanged}
              placeholder="Message de l'alerte"
            />
          </div>
          
          <div className='w-6 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.users' />
            </label>
            <MultiSelect name="users" 
                           className='w-full'
                           options={(staff || []).map(s=>({label: s.firstname + ' ' +s.lastname, value: s.userID}))}
                           value={inputs.users}
                           onChange={onInputChanged}/>
            {/*<InputText 
              className='w-full'
              name="users"
              value={inputs.users || ''}
              onChange={onInputChanged}
              placeholder="IDs utilisateurs séparés par des virgules"
            />*/}
          </div>
          
          <div className='w-6 p-2'>
            <label className="block mb-2 font-semibold">
              <OlangItem olang='alert.emails' />
            </label>
            <InputText 
              className='w-full'
              name="emails"
              value={inputs.emails || ''}
              onChange={onInputChanged}
              placeholder="Emails séparés par des virgules"
            />
          </div>
        </div>
        
        <div className='flex justify-content-end gap-2 mt-4'>
          <Button 
            onClick={back} 
            severity='secondary' 
            label="Annuler" 
            icon="pi pi-times" 
            className="p-button-sm" 
          />
          
          {/* Conteneur avec tooltip pour le bouton Enregistrer */}
          <span 
            className={`save-button-wrapper ${(!inputs.conditions || inputs.conditions.length === 0) ? 'disabled-wrapper' : ''}`}
            data-pr-tooltip={(!inputs.conditions || inputs.conditions.length === 0) ? 
              "Veuillez configurer au moins une condition avant de sauvegarder" : 
              "Enregistrer l'alerte"
            }
            data-pr-position="top"
          >
            <Button 
              onClick={save} 
              label="Enregistrer" 
              icon="pi pi-check" 
              className="p-button-sm"
              loading={loading}
              disabled={loading || !inputs.conditions || inputs.conditions.length === 0}
            />
          </span>
          
          {/* Tooltip global pour les éléments avec data-pr-tooltip */}
          <Tooltip target=".save-button-wrapper" />
        </div>
      </div>
    </div>
  )
}

export default AlertEditor
